import { inject, Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';
import {
  createPass,
  createPassFailure,
  createPassSuccess,
  forgotPass,
  forgotPassFailure,
  forgotPassSuccess,
  login,
  loginFailure,
  loginSuccess,
  logout,
  logoutSuccess,
  verifyOTP,
  verifyOTPFailure,
  verifyOTPSuccess,
} from './authentication.actions';
import { AuthenticationService } from '@core/services/auth.service';

@Injectable()
export class AuthenticationEffects {
  private actions$ = inject(Actions);

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),
      exhaustMap(({ email, password }) => {
        return this.authService.login(email, password).pipe(
          map((user) => {
            if (user) {
              const returnUrl =
                this.route.snapshot.queryParams['returnUrl'] || '/';
              this.router.navigateByUrl(returnUrl);
            }
            return loginSuccess({ user });
          }),
          catchError((error) => of(loginFailure({ error })))
        );
      })
    )
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(logout),
      exhaustMap(() => {
        this.authService.logout();
        this.router.navigate(['/auth/login']);
        return of(logoutSuccess());
      })
    )
  );

  createPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createPass),
      exhaustMap(({ email, password, token }) => {
        return this.authService.createPass(email, password, token).pipe(
          map(({ message }) => {
            return createPassSuccess({ message });
          }),
          catchError((data) => of(createPassFailure(data)))
        );
      })
    )
  );
  forgotPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(forgotPass),
      exhaustMap(({ email }) => {
        return this.authService.forgetPassword(email).pipe(
          map(({ message, success }) => {
            return forgotPassSuccess({ message, success });
          }),
          catchError((data) => of(forgotPassFailure(data)))
        );
      })
    )
  );
  verifyOTP$ = createEffect(() =>
    this.actions$.pipe(
      ofType(verifyOTP),
      exhaustMap((data) => {
        return this.authService.verifyOTP(data).pipe(
          map(({ message, success }) => {
            return verifyOTPSuccess({ message, success });
          }),
          catchError((data) => of(verifyOTPFailure(data)))
        );
      })
    )
  );
}
